import { LayoutDefault } from 'components/layout';
import { ComponentType } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { userDetailsState } from 'store/userDetailsSlice';

interface PrivateRouteProps {
  component: ComponentType;
  path: string;
  exact?: boolean;
  noLayout?: boolean;
}
export default function PrivateRoute({
  component: Component,
  noLayout,
  ...rest
}: PrivateRouteProps) {
  const { loggedIn } = useSelector(userDetailsState);

  const componentToRender = noLayout ? (
    <Component />
  ) : (
    <LayoutDefault>
      <Component />
    </LayoutDefault>
  );

  return (
    <Route
      {...rest}
      render={({ location }) =>
        loggedIn ? (
          componentToRender
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
